// D-0099 — NF por parcela no link do fornecedor: quais parcelas esta nota cobre.
// Os ids chegam como texto da API (o id da parcela passa de 2^53 e o Number do JS arredonda): nunca converter.

export const pendentes = (parcelas) => (parcelas || []).filter((p) => !p.tem_nf);

// Padrão é uma nota por parcela: começa marcada a primeira que ainda espera nota.
export const marcadasIniciais = (parcelas) => {
    const p = pendentes(parcelas);
    return p.length ? [String(p[0].id)] : [];
};

export const alternarMarcada = (marcadas, id) => {
    const s = String(id);
    return marcadas.includes(s) ? marcadas.filter((m) => m !== s) : [...marcadas, s];
};

// Valor exato desta nota = soma das parcelas marcadas (em centavos, sem sobra de ponto flutuante).
export const valorMarcadas = (parcelas, marcadas) => (parcelas || [])
    .filter((p) => !p.tem_nf && marcadas.includes(String(p.id)))
    .reduce((t, p) => t + Math.round(Number(p.valor || 0) * 100), 0) / 100;

// Ids na ordem do plano, só os que ainda esperam nota — é o que vai no envio.
export const idsParaEnviar = (parcelas, marcadas) => pendentes(parcelas)
    .map((p) => String(p.id))
    .filter((id) => marcadas.includes(id));

export const rotuloParcela = (p) => `Parcela ${p.numero} de ${p.total}`;

export const avisoParcelas = (parcelas, marcadas) => (pendentes(parcelas).length > 0 && idsParaEnviar(parcelas, marcadas).length === 0
    ? 'Marque a parcela que esta nota cobre.'
    : null);
